import React, { useRef } from 'react';
import { TextField, InputAdornment, IconButton, TextFieldProps } from '@mui/material';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';

interface DatePickerFieldProps extends Omit<TextFieldProps, 'onChange'> {
  value: string | null | undefined;
  onChange: (value: string) => void;
  label?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

const DatePickerField: React.FC<DatePickerFieldProps> = ({
  value,
  onChange,
  label,
  error,
  helperText,
  disabled,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (inputRef.current && inputRef.current.showPicker) {
      inputRef.current.showPicker();
    }
  };

  return (
    <TextField
      {...props}
      fullWidth
      type="date"
      label={label}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      error={error}
      helperText={helperText}
      disabled={disabled}
      inputRef={inputRef}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <IconButton 
              size="small" 
              edge="start"
              onClick={handleClick}
              disabled={disabled}
            >
              <CalendarIcon />
            </IconButton>
          </InputAdornment>
        ),
        sx: {
          cursor: 'pointer',
          '& .MuiInputBase-input': {
            cursor: 'pointer',
          },
        },
      }}
      onClick={handleClick}
    />
  );
};

export default DatePickerField;